import { Box, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { BacklogTableCellSelect } from "../components/BacklogTableCellSelect";
import DateTimePickerApprover from "../components/DateTimePickerApprover";
import { select_options } from "./approverCommanColumnProperties";
import axiosInstance from "../../../http-common";

export const render_approval_ud_date_picker = (props) => {
  const { colDef, row } = props;
  const { field } = colDef;
  // const status = row[field];
  return <DateTimePickerApprover field={field} row={row} />;
};

export const Render_approval_status_cell = (props) => {
  const { colDef, row, api } = props;
  const { field } = colDef;
  const [status, set_status] = useState(row[field]);
  if (status === "N") {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          // padding: "10px",
          // margin: "10px",
          // backgroundColor: status_to_background_color_mapping[row[field]],
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <p className="text-sm p-2">Not Required</p>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          width: "100%",
          // height: "100%",
          // padding: "10px",
          // margin: "10px",
          // backgroundColor: status_to_background_color_mapping[row[field]]
        }}
      >
        <Select
          sx={{
            width: "100%",
          }}
          labelId={`${field}-${row.id}-label`}
          id={`${field}-${row.id}`}
          value={row.approval || "Pending"}
          // label="Status"
          // disabled={is_disabled}
          // size='small'
          onChange={(e) => {
            // set_select_status(e.target.value);
            set_status(e.target.value);
            console.log(row, e.target.value);
            // dispatch(handle_backlog_reviewer_remarks_update(backlog, e, excel_row, excel_row.id, key_name));
            const approval_patcher = async (
              batch_no,
              material_type,
              approval
            ) => {
              var formdata = new FormData();
              formdata.append("batch_no", batch_no);
              formdata.append("material_type", material_type);
              formdata.append("remark", "Awaiting Approval");
              formdata.append("approval", approval);

              try {
                const response = await axiosInstance.post(
                  `/v1/qc/update_backlog_status/`,
                  formdata,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  }
                );
                console.log(response.data);
                if (response?.data?.status === "success") {
                  api?.updateRows([{ id: row?.id, approval }]);
                }
              } catch (error) {
                console.error("error", error);
              }
            };
            // console.log({ row });
            approval_patcher(
              row["batch_number"],
              row["Material Type"],
              e.target.value
            );
          }}
        >
          {select_options.approval_options.map(({ value, label }, index) => (
            <MenuItem
              key={`${row.id}-${value}-${label}-${field}-${index}`}
              value={value}
            >
              {label}
            </MenuItem>
          ))}
        </Select>
        <BacklogTableCellSelect
          excel_row={row}
          key_name={field}
          select_options={[...select_options.approval_options]}
          select_status={row[field] || "Pending"}
        />
      </Box>
    );
  }
};

export const Render_ud_status_cell = (props) => {
  const { colDef, row } = props;
  const { field } = colDef;
  const [status, set_status] = useState(row[field]);
  if (status === "N") {
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          // padding: "10px",
          // margin: "10px",
          // backgroundColor: status_to_background_color_mapping[row[field]],
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
        }}
      >
        <p className="text-sm p-2">Not Required</p>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          width: "100%",
          // height: "100%",
          // padding: "10px",
          // margin: "10px",
          // backgroundColor: status_to_background_color_mapping[row[field]]
        }}
      >
        <Select
          sx={{
            width: "100%",
          }}
          labelId={`${field}-${row.id}-label`}
          id={`${field}-${row.id}`}
          value={row?.["UD remark"] || "Pending"}
          // label="Status"
          // disabled={is_disabled}
          // size='small'
          onChange={(e) => {
            // set_select_status(e.target.value);
            set_status(e.target.value);
            console.log(row, e.target.value);
            // dispatch(handle_backlog_reviewer_remarks_update(backlog, e, excel_row, excel_row.id, key_name));
            const ud_patcher = (batch_no, UD_remark) => {
              var formdata = new FormData();
              formdata.append("batch_no", batch_no);
              formdata.append("remark", "Under UD");
              formdata.append("UD_remark", UD_remark);

              var requestOptions = {
                method: "POST",
                body: formdata,
                redirect: "follow",
              };

              fetch(
                "https://demo-optimus.backend-ripik.com/v1/qc/update_backlog_status/",
                requestOptions
              )
                .then((response) => response.json())
                .then((result) => {
                  console.log(result);
                  // dispatch(load_intm_backlog_from_backend());
                })
                .catch((error) => console.log("error", error));
            };
            ud_patcher(row["Batch Number"], e.target.value);
          }}
        >
          {select_options.ud_options.map(({ value, label }, index) => (
            <MenuItem
              key={`${row.id}-${value}-${label}-${field}-${index}`}
              value={value}
            >
              {label}
            </MenuItem>
          ))}
        </Select>
        <BacklogTableCellSelect
          excel_row={row}
          key_name={field}
          select_options={[...select_options.approval_options]}
          select_status={row[field] || "Pending"}
        />
      </Box>
    );
  }
};
